<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_vo="customVuexName + 'Vo'"
                                           :$_em-custom-vuex-mixin_filter="customVuexName + 'Filter'"
                                           :query-api="queryApi"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesQualityProductionSampleResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      :header-btn-add-disabled="isInspect"
                                      :header-btn-edit-disabled="isInspect"
                                      with-custom-row-actions-first-column
                                      :$_em-custom-vuex-mixin_vo="customVuexName + 'Vo'"
                                      :$_em-custom-vuex-mixin_filter="customVuexName + 'Filter'"
                                      :$_em-custom-vuex-mixin_entity="customVuexName + 'Entity'"
                                      :query-api="queryApi"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template slot="left-header">
                                    <b-button-group>
                                        <em-button type="search"
                                                   class="btn btn-outline-primary btn-sm"
                                                   customLabel="送检"
                                                   custom-icon="fa fa-arrow-right"
                                                   show-name
                                                   v-if="!isInspect"
                                                   :disabled="actionDisabled('select')"
                                                   @click="changeStatus('sendToInspect')">
                                        </em-button>
                                        <em-button type="search"
                                                   class="btn btn-outline-primary btn-sm"
                                                   customLabel="接收"
                                                   custom-icon="fa fa-arrow-right"
                                                   show-name
                                                   v-if="isInspect"
                                                   :disabled="actionDisabled('select')"
                                                   @click="changeStatus('receive')">
                                        </em-button>
                                        <em-button type="search"
                                                   class="btn btn-outline-primary btn-sm"
                                                   customLabel="完成"
                                                   custom-icon="fa fa-circle"
                                                   confirm-text="确认完成吗，完成后将无法修改"
                                                   show-name
                                                   v-if="isInspect"
                                                   :disabled="actionDisabled('select')"
                                                   @click="changeStatus('finish')">
                                        </em-button>
                                        <em-button type="search"
                                                   class="btn btn-outline-primary btn-sm"
                                                   customLabel="复测"
                                                   custom-icon="fa fa-repeat"
                                                   confirm-text="是否确认复测"
                                                   show-name
                                                   v-if="isInspect"
                                                   :disabled="actionDisabled('selectOne')"
                                                   @click="reinspect">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                                   custom-icon="fa fa-th-list"
                                                   class="btn btn-outline-primary btn-sm"
                                                   v-if="!isInspect"
                                                   custom-label="查看样品检验结果"
                                                   @click="viewInspectResults(customRowScope.row)">
                                        </em-button>
                                        <em-button type="gotoChild"
                                                   class="btn btn-outline-primary btn-sm"
                                                   customLabel="查看样品检验详情"
                                                   v-else
                                                   @click="gotoChildPage(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <re-b-modal ref="inspectResult" header="检验数据查看">
            <mini-table ref="inspectResultTable"
                        read-only :fields="fields"
                        :filter-holder="filterHolder"
                        entity-name="mintalMesQualityProductionSampleItem"></mini-table>
        </re-b-modal>
    </div>
</template>
<script>
// Author Liang Gang Qiang
// Date 2021-10-13 14:43:42

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import customVuexNameMixin from "@/mixin/em/common/stuffs/customVuex/customVuexNameMixin";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import {mapState} from "vuex";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";

export default {
    name: "mintalMesQualityProductionSampleListView",
    components: {MiniTable, ReBModal},
    mixins: [emCommonListMixin, emCommonGotoMixin, emTableCheckedMixin, customVuexNameMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        },
        customVuexNameInit: {
            type: String,
            default: null
        }
    },
    computed: {
        ...mapState({
            routeId: state => state.routeStore.id,
            routeRow: state => state.routeStore.object
        }),
        modelName() {
            return 'mintalMesQualityProductionSample';
        },
        isInspect() {
            return this.customVuexName === 'inspect';
        },
        queryApi() {
            return 'findByFilter' + (this.isInspect ? '/inspector' : '');
        }
    },
    data() {
        return {
            customVuexName: 'create',
            fields: [
                {key: 'compoundName', label: '元素名称'},
                {key: 'upperLimit', label: '上限值'},
                {key: 'lowerLimit', label: '下限值'},
                {key: 'compoundUnit', label: '单位'},
                {key: 'measurement', label: '实测值'},
                {
                    key: 'qualified', label: '判定结果', type: 'select',
                    options: [
                        {value: '0', text: '无'},
                        {value: '1', text: '合格'},
                        {value: '2', text: '一级品'},
                        {value: '3', text: '二级品'},
                        {value: '4', text: '不合格'}
                    ]
                }
            ],
            filterHolder: {}
        }
    },
    watch: {
        customVuexNameInit() {
            if (this.customVuexNameInit != null) {
                this.customVuexName = this.customVuexNameInit;
            }
        }
    },
    mounted() {
        this.checkIsInspector();
    },
    methods: {
        gotoChildPage(row) {
            let filterHolder = {
                sampleIdFilter: row.id,
                sampleCodeFilter: row.code
            }
            if (row.maxIndex > 0) {
                filterHolder.indexFilter = row.maxIndex;
            }
            this.$_emGotoMixin_gotoHolderList("mintalMesQualityProductionSampleItem"
                , filterHolder, {sampleId: row.id, sampleCode: row.code}, false, {});
        },
        changeStatus(type) {
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_MINTALMES_QUALITY_URL + "/mintalMesQualityProductionSample/" + type + "?ids=" + this.selectIds
            }).then(() => {
                this.$message.success("Operation success");
                this.$refs.emListFilter.doQuery();
            })
        },
        reinspect() {
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_MINTALMES_QUALITY_URL + "/mintalMesQualityProductionSample/reinspect?id=" + this.selectIds
            }).then(() => {
                this.$message.success("Operation success");
                this.$refs.emListFilter.doQuery();
            })
        },
        doGoto() {
            if (this.routeId) {
                this.insertHolder('qualityProductionProjectId', this.routeId)
                this.insertHolder('qualityProductionProjectCode', this.routeRow.code)
            } else if (!this.isInspect) {
                // this.$router.push('/mintalMes/quality/mintalMesQualityProductionProjectList');
            }
            //inspectObject的查询
            if (this.$route.query.isObject) {
                this.insertHolder('inspectObject', this.routeRow.inspectObject);
                this.insertHolder('inspectTypeList', this.routeRow.inspectTypeList);
            }
        },
        checkIsInspector() {
            if (this.customVuexNameInit != null) {
                this.customVuexName = this.customVuexNameInit;
                this.doGoto();
            } else {
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_EM_ADMIN_URL + "/emAclRoleUser/isRoleByCode?code=inspector"
                }).then(response => {
                    if (response.data) {
                        this.customVuexName = 'inspect';
                    }
                }).finally(() => {
                    this.doGoto()
                });
            }
        },
        viewInspectResults(row) {
            this.filterHolder.sampleIdFilter = row.id;
            this.filterHolder.indexFilter = row.maxIndex;
            this.$refs.inspectResult.showModal();
            this.$nextTick(() => this.$refs.inspectResultTable.getRemoteData());
        }
    }
};
</script>
